import {
  NavigationMenu,
  NavigationMenuList,
} from "@radix-ui/react-navigation-menu";
import { NavBarItem } from "../molecules";
import { FC, useCallback } from "react";
import { SidebarContainer } from "../atoms";
import { useAtomValue } from "jotai";
import { facilityDataAtom, sidebarContentAtom } from "../../jotai-atoms";
import { MenuItem } from "../../types";
import FacilityBrandBox from "../molecules/facility-brand-box";

export interface SidebarProps {
  disabled?: boolean;
  onItemClick: (name: string) => void;
  activePageName: string;
}

export const Sidebar: FC<SidebarProps> = ({
  disabled,
  onItemClick,
  activePageName,
}) => {
  const facilityData = useAtomValue(facilityDataAtom);
  const sidebarContent = useAtomValue(sidebarContentAtom);

  const facilityShortName = facilityData?.facilityShortName;
  const brandName = facilityData?.brandName;

  const onClick = useCallback(
    ({ pages }: MenuItem) => {
      if (pages.length > 0) {
        onItemClick(pages[0].name);
      }
    },
    [onItemClick]
  );

  return (
    <SidebarContainer>
      {facilityShortName && brandName && (
        <FacilityBrandBox
          facilityShortName={facilityShortName}
          brandName={brandName}
        />
      )}
      <NavigationMenu orientation="vertical" className="overflow-auto h-full">
        <NavigationMenuList className="flex flex-col gap-[15px]">
          {sidebarContent?.navigationItems.map((item) => (
            <NavBarItem
              disabled={disabled}
              item={item}
              key={item.id}
              active={
                item.pages.find((page) => page.name === activePageName) !==
                undefined
              }
              onClick={() => onClick(item)}
            />
          ))}
        </NavigationMenuList>
      </NavigationMenu>
    </SidebarContainer>
  );
};
